import * as types from './mutations-types'
import pointsMailApi from '../../../../../api/wx-member/points-mall/points-mall'
import dictApi from '../../../../../api/dict/dictionary-api'
import FormatTableFieldUtils from '../../../../../common/utils/format-table-field-util'
import * as DictionaryConstants from '../../../../../constants/DictionaryConstants'
import * as DataTypeConstants from '../../../../../constants/DataTypeConstants'

export default {
  getMemberStoredValue: ({commit}, data) => {
    pointsMailApi.getMemberStoredValue(data)
      .then(result => {
        let params = [
          {
            fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
            fieldPropCode: 'changeType',
            fieldPropName: 'changeTypeName',
            fieldFormatParam: DictionaryConstants.MY_POINTS_TYPE
          },
          {
            fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
            fieldPropCode: 'cardDefinitionId',
            fieldPropName: 'cardDefinitionIdName',
            fieldFormatParam: DictionaryConstants.MY_CARD_TYPE
          }
        ]
        FormatTableFieldUtils.formatTableFieldName(result.dataList, params).then(res => {
          result.dataList = res
          commit(types.MY_STORED_VALUE, result)
        })
      })
  },
  getMemberStoredValueCardDefinitionId: ({commit}, data) => {
    dictApi.getSelectedDetails(DictionaryConstants.MY_CARD_TYPE)
      .then(result => {
        let res = result.filter(item => {
          data.filter(itemTwo => {
            if (item.dictCode * 1 === itemTwo.definitionId * 1) {
              item.openFlag = true
              item.accountBalance = itemTwo.accountBalance
              item.instanceCode = itemTwo.instanceCode
            }
          })
          return item
        })
        commit(types.STORED_VALUE_CARD_DEFINITION, res)
      })
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-stored-value/store/actions.js